import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { PillViewType } from '../../../../types';
import { PillDragProvider } from '../../context';
import { RemovablePill } from '../RemovablePill';

type SortablePillPropsType = {
  pill: PillViewType;
  sortableId: string;
  isDragDisabled: boolean;
  onRemove: () => void;
  onClick?: () => void;
};

export const SortablePill: React.FC<SortablePillPropsType> = ({
  pill,
  sortableId,
  isDragDisabled,
  onRemove,
  onClick,
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    setActivatorNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: sortableId,
    disabled: isDragDisabled,
  });

  return (
    <span
      ref={setNodeRef}
      style={{
        transform: CSS.Transform.toString(transform),
        transition,
      }}
    >
      <PillDragProvider
        value={{
          attributes,
          listeners,
          setActivatorNodeRef,
          isDragging,
        }}
      >
        <RemovablePill
          label={pill.label}
          color={pill.color}
          isActive={pill.isActive}
          onRemove={onRemove}
          onClick={onClick}
        />
      </PillDragProvider>
    </span>
  );
};
